var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tabs),function(header,index){return (header.id === _vm.activeTab)?_c('div',{key:index},[_vm._t(header.id)],2):_vm._e()}))}
var staticRenderFns = []

export { render, staticRenderFns }